import { Partial } from '@40seas/entities/common';
import { CreateCheckoutDto } from './create.checkout.dto';

export class UpdateCheckoutDto extends Partial(CreateCheckoutDto) {}
